import { Injectable } from '@angular/core';

import { IHeadingWithConfig, PositionEnum } from '@seb/web-design-system/core';

import { transformHeadlineLevelToTitleLevel } from './title-level.mapper';
import { BaseStoreService } from '../services/base-store.service';
import { ImageService } from '../services/image.service';

@Injectable({
  providedIn: 'root'
})
export class HeadingParagraphMapper {
  constructor(
    private imageService: ImageService,
    private baseStoreService: BaseStoreService
  ) {}

  toHeadingParagraph(cmp?: any): IHeadingWithConfig {
    if (cmp.heading?.headline || cmp.heading?.subline || cmp.heading?.description || cmp.headline || cmp.subline || cmp.description) {
      const brandCornerList = JSON.stringify(this.baseStoreService.baseStore.brandsCorner);
      const brands = brandCornerList && brandCornerList !== 'undefined' ? JSON.parse(brandCornerList) : undefined;
      const brandFound = brands?.find((brand)=> brand.id === cmp?.brandCorner);
      return {
        data: {
          title: cmp.heading?.headline ?? cmp.headline ?? '',
          description: cmp.heading?.description ?? cmp?.description ?? '',
          subtitle: cmp.heading?.subline ?? cmp.subline ?? '',
          media: this.imageService.normalizeMedia(cmp.heading?.media) ?? undefined,
          brandLogo: cmp.heading?.brandLogo ? {
            media: cmp.heading?.brandLogo?.media ?? cmp.brandLogo?.media,
            position: cmp.heading?.brandLogo?.position ?? cmp.brandLogo?.position,
            size: cmp.heading?.brandLogo?.size ?? cmp.brandLogo?.size
          } : brandFound?.logo
            ? {
              media: brandFound.logo,
              position: PositionEnum.top
            }
            : undefined
        },
        titleThemesConfig: typeof cmp.titleTheme === 'string' ? cmp.titleTheme.toLowerCase() :
          cmp.titleTheme && cmp.titleTheme.titleThemesConfig ? cmp.titleTheme.titleThemesConfig.toString().toLowerCase() :
            cmp.theme?.toLowerCase() ?? undefined,
        themesConfig: cmp.themesConfig ?? undefined,
        isUnderlined: cmp.isUnderlined ?? undefined,
        limit: cmp.limit ?? undefined,
        size: cmp.size ?? undefined,
        readMore: cmp.readMore ?? undefined,
        iconSize: cmp.iconSize ?? undefined,
        iconNameOpened: cmp.iconNameOpened ?? undefined,
        iconNameClosed: cmp.iconNameClosed ?? undefined,
        idReadMore: cmp.idReadMore ?? undefined,
        titleLevel: transformHeadlineLevelToTitleLevel(cmp?.heading?.headlineLevel ?? cmp?.headlineLevel),
        textConfig: cmp.heading?.textConfig?.toLowerCase() ?? cmp.textConfig?.toLowerCase() ?? undefined,
        isDescription: (cmp.heading?.isDescription?.toString() ?? cmp.isDescription?.toString()) === 'true'
      };
    }
    return undefined;
  }
}
